var exports = {
  "uW": "PricingSection.module__section___RE5pQn",
  "E3": "PricingSection.module__toggleContainer___RE5pQn",
  "xQ": "PricingSection.module__footerContainer___RE5pQn",
  "$P": "PricingSection.module__scrollPromptContainer___RE5pQn",
  "Zq": "PricingSection.module__scrollPromptText___RE5pQn",
  "$O": "PricingSection.module__scrollPromptIcon___RE5pQn",
};

module.exports = exports;
